<template>
    <div class="Orderer" @click="Clicked">
        {{ OrdererName }}
    </div>
</template>

<script>
export default{
    props:{
        OrdererName: String,
        ID: Number,
        OnClick: Function
    },
    methods:{
        Clicked(){
            console.log('click');
            this.OnClick(this.ID, this.OrdererName);
        }
    }
}
</script>

<style>
.Orderer
{
    cursor: pointer !important;
    padding: 3px 2px 3px 4px !important;
    margin: 0px !important;
    background-color: rgba(65, 184, 131, 0);
    transition: 0.2s;
    -webkit-transition: 0.2s;
    -moz-transition: 0.2s;
}

.Orderer:hover
{
    background-color: rgba(65, 184, 131, 1.0);
}
</style>